/*
 * nf-motion.js — Fase 6: apoio JS as microinteracoes (carregado com defer).
 * -------------------------------------------------------------------------
 * Responsabilidades (todas leves, sem framework, sem tocar internals do Dawn):
 *   1. .nf-scrolled no <html> quando descola do topo (scroll passivo + rAF)
 *      -> ativa o header "frosted" definido em nf-motion.css;
 *   2. estado "Adicionado" com check no botao que disparou o add (cartUpdate);
 *   3. pulso da bolha do carrinho apos o re-render da secao;
 *   4. pulso da barra de frete gratis ao cruzar o limiar (travado->desbloqueado);
 *   5. rotacao do icone do toggle de tema ao ouvir 'nf:theme-change';
 *   6. micro fade-slide de preco/parcelamento na troca de variante.
 *
 * Tudo que e puramente decorativo tambem esta atras de prefers-reduced-motion
 * no CSS; aqui apenas alternamos classes, entao respeitamos a preferencia sem
 * checagem extra. As classes de pulso so sao adicionadas quando ha permissao
 * de movimento, para nao sujar o DOM a toa.
 */
(function () {
  if (window.nfMotionLoaded) return;
  window.nfMotionLoaded = true;

  var root = document.documentElement;
  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', function (e) {
      reduceMotion = e.matches;
    });
  } catch (e) {}

  /* ---------------------------------------------------------
     1. Header frosted ao rolar
     --------------------------------------------------------- */
  var SCROLL_ON = 4; // px: descolou do topo
  var scrolled = false;
  var ticking = false;

  function updateScrolled() {
    var y = window.pageYOffset || root.scrollTop || 0;
    var next = y > SCROLL_ON;
    if (next !== scrolled) {
      scrolled = next;
      root.classList.toggle('nf-scrolled', scrolled);
    }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScrolled);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateScrolled();

  /* ---------------------------------------------------------
     2. Botao "Adicionado" — rastreia o ultimo botao de add clicado
     --------------------------------------------------------- */
  var pendingBtn = null;
  var pendingAt = 0;
  var ADD_SELECTOR = 'button[name="add"], .quick-add__submit, [data-nf-sticky-add]';

  document.addEventListener(
    'click',
    function (evt) {
      var btn = evt.target && evt.target.closest ? evt.target.closest(ADD_SELECTOR) : null;
      if (btn) {
        pendingBtn = btn;
        pendingAt = Date.now();
      }
    },
    true
  );

  function showAdded(btn) {
    if (reduceMotion || !btn || !btn.isConnected) return;
    if (btn.classList.contains('nf-atc--added')) return;

    var check = btn.querySelector(':scope > .nf-atc__check');
    if (!check) {
      check = document.createElement('span');
      check.className = 'nf-atc__check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
        'stroke-linecap="round" stroke-linejoin="round" focusable="false">' +
        '<path d="M5 12.5 10 17.5 19.5 7"/></svg>';
      btn.appendChild(check);
    } else {
      // reinicia a animacao do traco
      var path = check.querySelector('path');
      if (path) {
        path.style.animation = 'none';
        // reflow para reiniciar
        void path.offsetWidth;
        path.style.animation = '';
      }
    }

    btn.classList.add('nf-atc--added');
    window.setTimeout(function () {
      btn.classList.remove('nf-atc--added');
    }, 1200);
  }

  /* ---------------------------------------------------------
     3+4. Pulsos (bolha do carrinho / barra de frete)
     --------------------------------------------------------- */
  function pulseBubble() {
    if (reduceMotion) return;
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('nf-cart-bubble-pulse');
    void bubble.offsetWidth;
    bubble.classList.add('nf-cart-bubble-pulse');
    window.setTimeout(function () {
      bubble.classList.remove('nf-cart-bubble-pulse');
    }, 500);
  }

  var shipUnlocked = null; // estado anterior (null = nao inicializado)

  function anyShipUnlocked() {
    var nodes = document.querySelectorAll('[data-nf-shipping-progress]');
    if (!nodes.length) return null;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains('nf-shipping-progress--unlocked')) return true;
    }
    return false;
  }

  function pulseShipping() {
    if (reduceMotion) return;
    var nodes = document.querySelectorAll('[data-nf-shipping-progress].nf-shipping-progress--unlocked');
    nodes.forEach(function (node) {
      node.classList.remove('nf-shipping-progress--pulse');
      void node.offsetWidth;
      node.classList.add('nf-shipping-progress--pulse');
      window.setTimeout(function () {
        node.classList.remove('nf-shipping-progress--pulse');
      }, 500);
    });
  }

  function checkShippingCrossing() {
    var now = anyShipUnlocked();
    if (now === null) {
      shipUnlocked = null;
      return;
    }
    if (shipUnlocked === false && now === true) {
      pulseShipping();
    }
    shipUnlocked = now;
  }

  /* ---------------------------------------------------------
     Assinatura dos eventos do carrinho (pubsub do Dawn)
     --------------------------------------------------------- */
  function onCartUpdate(event) {
    var source = event && event.source;

    // check "Adicionado" so quando veio de um add (nao de +/- de quantidade)
    if (source !== 'cart-items' && pendingBtn && Date.now() - pendingAt < 6000) {
      showAdded(pendingBtn);
    }
    pendingBtn = null;

    // bolha + barra de frete atualizam apos o re-render das secoes (setTimeout do Dawn)
    window.setTimeout(function () {
      pulseBubble();
      checkShippingCrossing();
    }, 350);
  }

  function initPubSub() {
    // PUB_SUB_EVENTS e um `const` global do Dawn (constants.js), NAO uma
    // propriedade de window — por isso a referencia e bare, via typeof.
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    if (PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        pendingBtn = null;
      });
    }
    if (PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
    return true;
  }

  /* ---------------------------------------------------------
     6. Micro fade-slide de preco/parcelamento na troca de variante
     --------------------------------------------------------- */
  function onVariantChange(event) {
    if (reduceMotion) return;
    var info = null;
    var target = event && event.target;
    if (target && target.closest) info = target.closest('product-info');
    if (!info) info = document.querySelector('product-info');
    if (!info) return;

    // apos o re-render do bloco de preco pelo product-info.js
    window.setTimeout(function () {
      var blocks = info.querySelectorAll('.price, [data-nf-installments]');
      blocks.forEach(function (el) {
        el.classList.remove('nf-price-fade');
        void el.offsetWidth;
        el.classList.add('nf-price-fade');
        window.setTimeout(function () {
          el.classList.remove('nf-price-fade');
        }, 200);
      });
    }, 30);
  }

  /* ---------------------------------------------------------
     5. Rotacao do icone do toggle de tema
     --------------------------------------------------------- */
  document.addEventListener('nf:theme-change', function () {
    if (reduceMotion) return;
    var toggles = document.querySelectorAll('nf-theme-toggle');
    toggles.forEach(function (t) {
      t.classList.remove('nf-theme-toggle--spin');
      void t.offsetWidth;
      t.classList.add('nf-theme-toggle--spin');
      window.setTimeout(function () {
        t.classList.remove('nf-theme-toggle--spin');
      }, 260);
    });
  });

  /* ---------------------------------------------------------
     Boot
     --------------------------------------------------------- */
  function boot() {
    shipUnlocked = anyShipUnlocked();
    if (!initPubSub()) {
      // pubsub ainda nao pronto: tenta de novo no proximo tick
      window.setTimeout(initPubSub, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
